import { isEmpty } from "lodash";
import { useState } from "react";
import { useApolloClient } from "@apollo/client/react";

import {
  formatMissingRequiredAttributesMessage,
  getMissingRequiredAttributeLabels,
} from "src/hooks/useTagFormValidator";
import { TAG_ATTRIBUTE_ACTION } from "src/consts/tags";
import { persistTagAttributeEdits } from "./TagAttributesModal.persist";

export const useTagAttributeSave = ({
  form,
  onClose,
  entityTag,
  tagTypeConfig,
  isNewTag,
  setNewTag,
  comments,
  entityId,
  tagTypes,
  tagsQueryTagTypes,
  editMode,
  readOnly,
  entityType,
  onTagUpdated,
  overlayOptionId,
  overlayMutate,
}) => {
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState(null);
  const client = useApolloClient();
  const canEditEntityTagAttributes =
    !readOnly &&
    form.uniqueAttrTypes.some(
      (attrType) => attrType.action !== TAG_ATTRIBUTE_ACTION.READONLY
    );

  const onSave = async () => {
    const invalidFields = form.onFormSave({ attributes: form.attributeValues });
    if (!isEmpty(invalidFields)) {
      form.setRequiredFieldsMessage(
        formatMissingRequiredAttributesMessage(
          getMissingRequiredAttributeLabels(
            invalidFields,
            tagTypeConfig,
            true,
            form.includeTagLevelAttributes
          )
        )
      );
      return;
    }
    form.setRequiredFieldsMessage(null);
    setIsSaving(true);
    try {
      await persistTagAttributeEdits({
        client,
        overlayOptionId,
        overlayMutate,
        isNewTag,
        editMode,
        entityTag,
        tagTypeConfig,
        displayValue: form.displayValue,
        updatedAttributes: form.updatedAttributes,
        updatedEntityTagAttributes: form.updatedEntityTagAttributes,
        setNewTag,
        comments,
        entityId,
        tagTypes,
        tagsQueryTagTypes,
        entityType,
        onTagUpdated,
        tagTypesForEntityCache: tagsQueryTagTypes || tagTypes,
      });
      setIsSaving(false);
      onClose();
    } catch (e) {
      setError(e);
      setIsSaving(false);
    }
  };

  return {
    isSaving,
    error,
    onSave,
    canEditEntityTagAttributes,
    canSave: form.includeTagLevelAttributes || canEditEntityTagAttributes,
    appliedCount: entityTag.appliedCount,
  };
};
